import type { InlineMediaProps } from './types';

/**
 * Renders a result/preview asset as an inline, autoplaying-looping-muted
 * `<video>` (when `isVideo`) or a plain `<img>`. Sizing/cropping comes from the
 * caller's `className`. For richer needs (playback control, mute toggle,
 * blurred backgrounds) use `PreviewSection` / `LightboxMedia` instead.
 */
const InlineMedia = ({
  src,
  isVideo,
  className,
  poster,
  alt = '',
  preload,
  onError,
}: InlineMediaProps) =>
  isVideo ? (
    <video
      className={className}
      src={src}
      poster={poster}
      preload={preload}
      autoPlay
      loop
      muted
      playsInline
    />
  ) : (
    <img className={className} src={src} alt={alt} onError={onError} />
  );

export default InlineMedia;
